import { useEffect, useRef } from 'react';

// Calls `refetch` when something that can change the list (a drawer, a dialog) goes from open to closed
export const useRefetchOnClose = (isOpen: boolean, refetch: VoidFunction) => {
  const wasOpenRef = useRef(isOpen);
  const refetchRef = useRef(refetch);

  refetchRef.current = refetch;

  useEffect(() => {
    if (wasOpenRef.current && !isOpen) refetchRef.current();

    wasOpenRef.current = isOpen;
  }, [isOpen]);
};
